import { useMemo } from 'react'
import { Button, HStack, VStack } from '@chakra-ui/react'
import NavBar from 'components/NavBar'
import { useSelector } from 'model/hooks'
import { IEntityType, NodeDataT } from 'shared/types'
import { AddIcon } from '@chakra-ui/icons'
import { useNavigate } from 'react-router-dom'
import { dbCreateWebinar } from 'controllers/webinars'
import _ from 'lodash'
import { NodeModel } from '@minoru/react-dnd-treeview'
import FileThree from 'components/FileThree'
import { dbUpdateFileTree } from 'controllers/fileThree'

const Webinars = () => {
  const navigate = useNavigate()
  const webinars = useSelector(state => state.webinars)
  const fileThreeDBData = useSelector(state => state.fileTree)

  const treeData = useMemo(() => {
    const dbTreeRaw = _.get(fileThreeDBData, IEntityType.WEBINARS, [])
    const dbTree = _.map(dbTreeRaw, el => {
      if (el.data && el.data.id) {
        const c = _.get(webinars, el.data.id)
        if (c) {
          return { ...el, text: _.get(c, 'title', 'unnamed') }
        } else {
          return null
        }
      } else {
        return el
      }
    })
    const res = _.compact(dbTree)
    const dbTreeDict = _.keyBy(dbTree, 'id')
    _.forEach(webinars, c => {
      if (!_.has(dbTreeDict, c.id)) {
        const n: NodeModel<NodeDataT> = {
          id: c.id,
          parent: 'root',
          text: c.title,
          droppable: false,
          data: {
            id: c.id
          }
        }
        res.push(n)
      }
    })
    return res
  }, [fileThreeDBData, webinars])

  const onChangeFileTree = (treeData: NodeModel<NodeDataT>[]) => {
    dbUpdateFileTree(IEntityType.WEBINARS, treeData)
  }

  const onCreateCourseClick = async () => {
    const id = await dbCreateWebinar()
    navigate(`/webinars/${id}`)
  }

  const navBarActions = (
    <HStack>
      <Button
        colorScheme='teal'
        leftIcon={<AddIcon />}
        onClick={onCreateCourseClick}
      >
        Создать вебинар
      </Button>
    </HStack>
  )

  return (
    <VStack w='full' h='full' spacing={0}>
      <NavBar hideBackButton title='Вебинары'>
        {navBarActions}
      </NavBar>
      <VStack align={'center'} w='full' h='full' p={4} overflowY={'auto'}>
        <VStack maxW='4xl' w='full'>
          <FileThree
            treeData={treeData}
            onChange={onChangeFileTree}
            onNodeClick={id => navigate(`/${IEntityType.WEBINARS}/${id}`)}
          />
        </VStack>
      </VStack>
    </VStack>
  )
}

export default Webinars
